// This is not the correct way to import 3P javascript libraries.
//
// We added the https://github.com/blueimp/JavaScript-Load-Image plugin directly in our code
// to quickly resolve an issue with image uploads.
//
// TODO AUTHOR-4451: Update this statement to
// import loadImage from our brazil dependencies.
//
// 2021: This is a good example of why TODOs don't work in comments.
// Almost 5 years later, we still haven't fixed it.

import loadImage from './lib/loadImage';

class ImageConverter {
  static processImage(imageFile, dataUrl, maxWidth, maxHeight) {
    return new Promise((resolve, reject) => {
      this.downscaleImage(dataUrl, maxWidth, maxHeight)
        .then(resolve)
        .catch(reject);
    });
  }

  static downscaleImage(dataUrl, maxWidth, maxHeight) {
    return new Promise((resolve, reject) => {
      const options = {
        maxHeight,
        maxWidth,
        canvas: true, // Use canvas to normalize GIFs into an image
      };

      const onload = (canvas) => {
        try {
          resolve(canvas.toDataURL('image/jpeg'));
        } catch (e) {
          /* if loadImage isn't successful, canvas.toDataURL
          will fail. reject to avoid failing silently */
          reject(e);
        }
      };

      const loadingImage = loadImage(dataUrl, onload, options);
      loadingImage.onerror = reject;
    });
  }
}

export default ImageConverter;
